import React, { Fragment } from 'react';
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import Hero from '../../components/hero/hero';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import About from '../../components/about/about';
import PolicySection from '../../components/PolicySection/PolicySection';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import AuditPromo from '../../components/AuditPromo/AuditPromo';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import CtaSection from '../../components/CtaSection/CtaSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import SameDayPromo from '../../components/SameDayPromo/SameDayPromo';


const HomePage = () => {
    usePageSeo({
        title: 'California Low-Voltage Design & Managed IT',
        description: 'BUILDLAB designs low-voltage, surveillance, and access control systems for California construction, and runs managed IT, cyber security, and AI for business.',
        keywords: 'California technology consulting, California low-voltage design, affordable housing technology California, construction tech design, low-voltage, surveillance, door access, fire and life safety, managed IT, AI business integration, statewide California, BUILDLAB',
    });

    return (
        <Fragment>
            <div>
                <Header />
                <main id="main-content" className="page_content">
                    <Hero />
                    <FeaturesSection />
                    <About />
                    <PolicySection />
                    <ServiceSection />
                    <AuditPromo />
                    <ProjectSection />
                    <BlogSection />
                    <CtaSection />
                </main>
                <Footer />
                <Scrollbar />
                <SameDayPromo />
            </div>
        </Fragment>
    )
};
export default HomePage;